// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Header from "../../../Header/Header";
// import SideBar from "../../../SideBar/SideBar";
// import Footer from "../../../Footer/Footer";
// import { bulidingicon } from "../../../imagepath";
// import FeatherIcon from "feather-icons-react/build/FeatherIcon";
// import { loadVirtualAccount } from "../../../HttpRequest/afterlogin";
// import { useSelector, useDispatch } from "react-redux";

// const LoadwalletThroughVirtualAccount = () => {
//   const [userid, setUserid] = useState("");
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const getUser = loadVirtualAccount();
//     setUserid(getUser.userId);
//     // dispatch(getProfile({ getUser }));
//     return () => {};
//   }, []);

//   const reducerData = useSelector((data) => {
//     return data.counter.value;
//   });

//   return (
//     <>
//       <div className="main-wrapper">
//         {/* Header */}
//         <Header />
//         {/* Sidebar */}
//         <SideBar />
//         {/* Page Wrapper */}
//         <div className="page-wrapper">
//           <div className="content container-fluid">
//             <div className="page-header">
//               <div className="row">
//                 <div className="col-sm-12">
//                   <div className="page-sub-header">
//                     <h3 className="page-title">
//                       Your Virtual Account with OxyLoans
//                     </h3>
//                     <ul className="breadcrumb">
//                       <li className="breadcrumb-item">
//                         <Link to="/dashboard">Dashboard</Link>
//                       </li>
//                       <li className="breadcrumb-item active">
//                         <Link to="/loadwaletThroughQr">QR Scanner</Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="card">
//               <div className="card-body">
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="student-personals-grp">
//                       <div className="card mb-0">
//                         <div className="card-body">
//                           <div className="heading-detail">
//                             <h4>Recommend</h4>
//                           </div>

//                           <ul style={{ listStyle: "block" }}>
//                             <li>OXYLRV{userid} is your virtual account.</li>
//                             <li>
//                               Add 'OXYLRV {userid}' as a beneficiary in your
//                               bank account and Initiate the fund transfer
//                             </li>
//                             <li>
//                               <strong><code>Note: </code></strong> We are currently experiencing an issue with ICICI Bank and SBI while adding a beneficiary. If you are unable to add a beneficiary from these banks, please use another bank account to load your wallet.
//                             </li>

//                             <li>
//                               After the funds are transferred to the account,
//                               your wallet will be loaded automatically.
//                             </li>
//                             <li>
//                               You will receive notifications on your WhatsApp
//                               and email with the transaction details.
//                             </li>
//                             <li>
//                               Keep in mind that we only accept payments in INR,
//                               If you have any queries, please reach out to us by
//                               :{" "}
//                               <Link className="virtualList" to="/writetous">
//                                 Click Here
//                               </Link>
//                             </li>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-lg-6">
//                     <div className="student-personals-grp">
//                       <div className="card">
//                         <div className="card-body">
//                           <div className="heading-detail">
//                             <h4>Account Details :</h4>
//                           </div>
//                           <div className="personal-activity">
//                             <div className="personal-icons">
//                               <i className="feather-user">
//                                 <FeatherIcon icon="user" />
//                               </i>
//                             </div>
//                             <div className="views-personal">
//                               <h4>Account Name</h4>
//                               <h5> SRS FINTECHLABS PVT LTD</h5>
//                             </div>
//                           </div>
//                           <div className="personal-activity">
//                             <div className="personal-icons">
//                               <img src={bulidingicon} alt="" />
//                             </div>
//                             <div className="views-personal">
//                               <h4>Account Number </h4>
//                               <h5>OXYLRV{userid}</h5>
//                             </div>
//                           </div>
//                           <div className="personal-activity">
//                             <div className="personal-icons">
//                               <i className="feather-phone-call">
//                                 <FeatherIcon icon="alert-octagon" size={20} />
//                               </i>
//                             </div>
//                             <div className="views-personal">
//                               <h4>IFSC Code</h4>
//                               <h5>ICIC0000106</h5>
//                             </div>
//                           </div>
//                           <div className="personal-activity">
//                             <div className="personal-icons">
//                               <i className="feather-mail">
//                                 <FeatherIcon icon="briefcase" />
//                               </i>
//                             </div>
//                             <div className="views-personal">
//                               <h4>BANK</h4>
//                               <h5> ICICI</h5>
//                             </div>
//                           </div>
//                           <div className="personal-activity">
//                             <div className="personal-icons">
//                               <i className="feather-user">
//                                 <FeatherIcon icon="user" />
//                               </i>
//                             </div>
//                             <div className="views-personal">
//                               <h4>Account Type</h4>
//                               <h5>Current account</h5>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Footer */}
//           <Footer />
//         </div>
//       </div>
//       {/* /Main Wrapper */}
//     </>
//   );
// };

// export default LoadwalletThroughVirtualAccount;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import { bulidingicon } from "../../../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { loadVirtualAccount } from "../../../HttpRequest/afterlogin";

const LoadwalletThroughVirtualAccount = () => {
  const [userid, setUserid] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const getUser = loadVirtualAccount();
    setUserid(getUser.userId);

    return () => {};
  }, []);

  const virtualAccountNumber = `OXYLRV${userid}`;

  const handleCopy = async (value, type) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(type);

      setTimeout(() => {
        setCopied("");
      }, 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <div className="page-sub-header">
                    <h3 className="page-title">
                      Your Virtual Account with OxyLoans
                    </h3>

                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>

                      <li className="breadcrumb-item active">
                        <Link to="/loadwaletThroughQr">QR Scanner</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Card */}
            <div className="card">
              <div className="card-body">
                <div className="row">
                  {/* How To Load Wallet */}
                  <div className="col-lg-6">
                    <div className="student-personals-grp">
                      <div className="card mb-0">
                        <div className="card-body">
                          <div className="heading-detail mb-3">
                            <h4>How to Load Your Wallet</h4>
                          </div>

                          <ul
                            // style={{
                            //   paddingLeft: "25px",
                            //   marginBottom: "0",
                            // }}
                            style={{
                              listStyle: "block",
                              paddingLeft: "25px",
                              marginBottom: "0",
                            }}
                          >
                            <li
                              style={{
                                marginBottom: "15px",
                                paddingLeft: "5px",
                              }}
                            >
                              Your{" "}
                              <strong>
                                Virtual Account Number is OXYLRV{userid}
                              </strong>{" "}
                              — use this to transfer money from your bank.
                            </li>

                            <li
                              style={{
                                marginBottom: "15px",
                                paddingLeft: "5px",
                              }}
                            >
                              Add <strong>'OXYLRV{userid}'</strong> as a
                              beneficiary in your bank app or net banking.
                            </li>

                            <li
                              style={{
                                marginBottom: "15px",
                                paddingLeft: "5px",
                              }}
                            >
                              Transfer the amount you wish to invest — your{" "}
                              <strong>OxyLoans wallet</strong> will be loaded
                              automatically.
                            </li>

                            <li
                              style={{
                                marginBottom: "15px",
                                paddingLeft: "5px",
                              }}
                            >
                              You will receive a confirmation on{" "}
                              <strong>WhatsApp and email</strong> once the money
                              is credited.
                            </li>

                            <li style={{ paddingLeft: "5px" }}>
                              We only accept transfers in{" "}
                              <strong>INR (Indian Rupees)</strong>. For any
                              help,{" "}
                              <Link className="virtualList" to="/writetous">
                                <strong>Click Here</strong>
                              </Link>
                              .
                            </li>
                          </ul>

                          {/* Warning Box */}
                          <div
                            className="alert alert-warning mt-4 mb-0"
                            style={{
                              borderRadius: "10px",
                              padding: "16px 18px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "10px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "18px",
                                  lineHeight: "1.5",
                                }}
                              >
                                ⚠️
                              </span>

                              <div>
                                <strong
                                  style={{
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Having trouble?
                                </strong>

                                <span>
                                  If you are using <strong>ICICI Bank</strong>{" "}
                                  or <strong>SBI</strong> and are unable to add
                                  the beneficiary or transfer funds, please try
                                  using a{" "}
                                  <strong>different bank account</strong> to
                                  load your wallet.
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Account Details */}
                  <div className="col-lg-6">
                    <div className="student-personals-grp">
                      <div className="card">
                        <div className="card-body">
                          <div className="heading-detail">
                            <h4>Account Details :</h4>
                          </div>

                          <div
                            style={{
                              marginTop: "20px",
                              paddingLeft: "25px",
                              marginBottom: "0",
                            }}
                          >
                            {/* Account Name */}
                            <div className="personal-activity">
                              <div className="personal-icons">
                                <i className="feather-user">
                                  <FeatherIcon icon="user" />
                                </i>
                              </div>

                              <div className="views-personal">
                                <h4>Account Name</h4>
                                <h5>SRS FINTECHLABS PVT LTD</h5>
                              </div>
                            </div>

                            {/* Account Number */}
                            <div className="personal-activity">
                              <div className="personal-icons">
                                <img src={bulidingicon} alt="" />
                              </div>

                              <div className="views-personal">
                                <h4>Account Number</h4>

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <h5 style={{ margin: 0, fontWeight: "700" }}>
                                    {virtualAccountNumber}
                                  </h5>

                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleCopy(
                                        virtualAccountNumber,
                                        "account",
                                      )
                                    }
                                    title={
                                      copied === "account"
                                        ? "Copied"
                                        : "Copy account number"
                                    }
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      padding: "3px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={
                                        copied === "account" ? "check" : "copy"
                                      }
                                      size={16}
                                      color={
                                        copied === "account" ? "green" : "black"
                                      }
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* IFSC Code */}
                            <div className="personal-activity">
                              <div className="personal-icons">
                                <i className="feather-phone-call">
                                  <FeatherIcon icon="alert-octagon" size={20} />
                                </i>
                              </div>

                              <div className="views-personal">
                                <h4>IFSC Code</h4>

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <h5 style={{ margin: 0, fontWeight: "700" }}>
                                    ICIC0000106
                                  </h5>

                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleCopy("ICIC0000106", "ifsc")
                                    }
                                    title={
                                      copied === "ifsc"
                                        ? "Copied"
                                        : "Copy IFSC code"
                                    }
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      padding: "3px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={
                                        copied === "ifsc" ? "check" : "copy"
                                      }
                                      size={16}
                                      color={
                                        copied === "ifsc" ? "green" : "black"
                                      }
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* Bank */}
                            <div className="personal-activity">
                              <div className="personal-icons">
                                <i className="feather-mail">
                                  <FeatherIcon icon="briefcase" />
                                </i>
                              </div>

                              <div className="views-personal">
                                <h4>BANK</h4>
                                <h5>ICICI</h5>
                              </div>
                            </div>

                            {/* Account Type */}
                            <div className="personal-activity">
                              <div className="personal-icons">
                                <i className="feather-user">
                                  <FeatherIcon icon="user" />
                                </i>
                              </div>

                              <div className="views-personal">
                                <h4>Account Type</h4>
                                <h5>Current account</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <Footer />
        </div>
      </div>

      {/* /Main Wrapper */}
    </>
  );
};

export default LoadwalletThroughVirtualAccount;
